<a class="advanced-options uk-flex uk-flex-middle" (click)="switchAdvancedOptions()">
  <span i18n="@@AdvancedOptions">Advanced options</span>

  <span [hidden]="!(state | async).advancedOptionsOpen" uk-icon="chevron-down"></span>

  <span [hidden]="(state | async).advancedOptionsOpen" uk-icon="chevron-up"></span>
</a>
